import { setupTabs } from "@/components/tabs"
import { setupNavbar } from "@/components/navbar"
import { setupSitewidePromo } from "@/components/sitewide_promotion"

import AccordionController from "../controllers/accordion_controller"
import TrustpilotController from "../controllers/trustpilot_controller"

import Emarsys from "@/helpers/emarsys"
import { setupGa4 } from "@/helpers/ga4_helper"
import { register } from "@/helpers/stimulus"

import { setupFooter } from "@/components/footer"

const setTurboEval = (): void => {
  // Allow some GTM scripts to re-run by ignoring `data-turbo-eval="true"`
  const scriptSelector = "script:not([data-turbo-eval='true'])"

  document.querySelectorAll(scriptSelector).forEach((script) => {
    script.setAttribute("data-turbo-eval", "false")
  })
}

const scriptMutationObserver = (callback: () => void): void => {
  new window.MutationObserver((mutations): void => {
    mutations.forEach((mutation) => {
      if ([...mutation.addedNodes].some((node) => node.nodeName === "SCRIPT")) {
        callback()
      }
    })
  }).observe(document, { subtree: true, childList: true })
}

const setupStimulus = (): void => {
  register("accordion", AccordionController)
  register("trustpilot", TrustpilotController)
}

setupStimulus()

setupFooter()
setupTabs()
setupNavbar()
setupSitewidePromo()

// This gets called on every page to ensure the cart events get sent to emarsys.
Emarsys(window.emarsysData)

setupGa4()
setTurboEval()
scriptMutationObserver(setTurboEval)
